import { render } from "./viewModal.vue?vue&type=template&id=2d2c9a5d&scoped=true"
import script from "./viewModal.vue?vue&type=script&lang=js"
export * from "./viewModal.vue?vue&type=script&lang=js"

import "./viewModal.vue?vue&type=style&index=0&id=2d2c9a5d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2d2c9a5d"

export default script